/**
 * Copyright (C) 2021 - 2025 Philips Domestic Appliances Holding B.V.
 * All rights are reserved.
 */

import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { TitleStrategy } from '@angular/router';
import { AppTitleService } from '../../services/app-title/app-title.service';
import { AppTitleStrategy } from './app-title.strategy';

export function provideAppTitle(): EnvironmentProviders {
	return makeEnvironmentProviders([
		{ provide: TitleStrategy, useClass: AppTitleStrategy, deps: [AppTitleService] },
	]);
}
